module.exports = __webpack_public_path__ + "static/media/logotextweiss.88283368.png";